import styled from "styled-components";

export const Container = styled.div`
    margin-top: 6rem;
    width: 100%;
    display: flex;
`;

export const LeftDiv = styled.div`
    width: 50%;
    height: fit-content;
    margin-left: 8rem;

    > img {
        display: block;
        margin-left: auto;
        margin-right: auto;

        @media(min-width: 900px){
            width: 90%;
        }
        @media(max-width: 899px){
            width: 0%;
        }
    }

`;

export const RightDiv = styled.div`
    width: 50%;
    height: fit-content;
    margin-right: 8rem;
    margin-top: 3rem;

    > p {
        margin-top: 1rem;
        text-align: left;
        font: 600 15px/22px Mulish;
        letter-spacing: 0px;
        color: #787878;
        opacity: 1;
    }

    .titleDiv{
        display: flex;
        height: fit-content;

        > h3 { 
            text-align: left;
            font: normal normal 800 25px/19px Mulish;
            letter-spacing: 0px;
            color: #434343;
            opacity: 1;
            margin-left: .9rem;
            margin-top: 0.3rem;
        }

        > img {
            width: 25px;
        }
    }

    .addButton {
        margin-top: 1.5rem;
        width: 150px;

        .addIcon{
            padding-right: 5px;
        }
    }
`;

